module.exports = __webpack_public_path__ + "static/media/zhiyezhuang2.2710df13.png";